import { Segment } from "@ts/types/segment.type"
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "@components/dataDisplay/table/Table"

const priceFormatter = new Intl.NumberFormat("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })

const formatPrice = (n: number): string => priceFormatter.format(n).replaceAll("’", "'")
const signClass = (n: number): "negative" | "positive" => (n < 0 ? "negative" : "positive")

const IndexTable = ({ segment }: { segment: Segment }) => {
  return (
    <Table style={{ marginBottom: 10 }}>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Basiswert</TableHeaderCell>
          <TableHeaderCell align="right">Last</TableHeaderCell>
          <TableHeaderCell align="right">Change</TableHeaderCell>
          <TableHeaderCell align="right">%</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow>
          <TableCell>{segment.name}</TableCell>
          <TableCell align="right">{formatPrice(segment.titleInstrument.mid)}</TableCell>
          <TableCell align="right" numberType={signClass(segment.titleInstrument.change)}>
            {formatPrice(segment.titleInstrument.change)}
          </TableCell>
          <TableCell align="right" numberType={signClass(segment.titleInstrument.changePercent)}>
            {formatPrice(segment.titleInstrument.changePercent)}%
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}

export default IndexTable
